module.exports = __webpack_public_path__ + "static/media/s_14.4293702c.mp3";